import { styled } from '@mui/material';
import Tab, { tabClasses } from '@mui/material/Tab';
import { ReactNode } from 'react';

export const NavTab = styled(Tab)<{ to?: string; component?: ReactNode }>`
  transition: '.8s ease-in-out';
  opacity: 0.6;
  color: white;
  font-weight: bold;
  &.${tabClasses.selected} {
    opacity: 1;
    color: white;
  }
`;
